<div
    class="message"
    fxLayout fxLayoutAlign="center center"
    *ngIf="loading || error">
  <mat-spinner diameter="40" *ngIf="loading && !error"></mat-spinner>
  <span *ngIf="error">{{error}}</span>
</div>
<div [id]="chartId" [hidden]="loading || error"></div>